import React, { useState } from "react";
import { Plus } from "lucide-react";

// function WinnersFAQ() {
//   const [open, setOpen] = useState(0);

//   const items = [
//     {
//       q: "How does Winners verify a property listing?",
//       a: "Every listing passes through a 7-step verification process.",
//     },
//   ];

//   return (
//     <section className="ws-faq">
//       {/* same JSX from original component */}
//     </section>
//   );
// }

// export default WinnersFAQ;

export function WinnersFAQ() {
  const [open, setOpen] = useState(0);
  const items = [
    {
      q: "How does Winners verify a property listing?",
      a: "Every listing passes through a 7-step verification — ownership trail, RERA, encumbrance, physical visit, pricing benchmark, builder reputation and legal clearance — before it goes live."
    },
    {
      q: "Can I schedule a site visit through the platform?",
      a: "Yes. Pick any project, choose a time slot, and a dedicated relationship manager handles pickup, tour and follow-up."
    },
    {
      q: "Are the ROI numbers shown realistic?",
      a: "We use a blend of micro-market data, builder history and resale trends from the last 36 months. We always show the methodology behind each number."
    },
    {
      q: "What cities do you currently operate in?",
      a: "Twenty premium cities across NCR, UP and select metros — with active growth into tier-2 investment markets."
    },
    {
      q: "Do you charge buyers a fee?",
      a: "No buyer fees. We're compensated by partner builders and project sponsors, with full disclosure on every listing."
    },
  ];
  return (
    <section className="ws-faq">
      <div className="ws-faq-inner">
        <div className="ws-faq-side">
          <span className="ws-section-eyebrow">FAQ</span>
          <h2 className="ws-section-heading">Questions, answered with intent.</h2>
          <p>Everything you might want to know before exploring, visiting or investing in a Winners
            property. Can't find what you're looking for? Talk to us.</p>
          <button>Contact our team</button>
        </div>

        <div className="ws-faq-list">
          {items.map((it, i) => {
            const isOpen = open === i;
            return (
              <div className="ws-faq-item" key={it.q} data-open={isOpen}>
                <button className="ws-faq-q" onClick={() => setOpen(isOpen ? null : i)}>
                  {it.q}
                  <span className="ws-faq-q-ic"><Plus size={14} /></span>
                </button>
                {isOpen && <div className="ws-faq-a">{it.a}</div>}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}